import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/index.vue'
import { getToken } from "@/utils/auth";
const routes = [
  {
    path: '/logo',
    name: 'Logo',
    component: () => import('../views/logo.vue'),
    meta: { title: '登录页', icon: 'HomeFilled' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      },
      {
        path: 'online-office',
        name: 'OnlineOffice',
        component: () => import('../views/online-office.vue'),
        meta: { title: '在线办公', icon: 'OfficeBuilding' }
      },
      {
        path: 'employee-app',
        name: 'EmployeeApp',
        component: () => import('../views/employee-app.vue'),
        meta: { title: '员工app', icon: 'User' }
      },
      {
        path: 'customer-app',
        name: 'CustomerApp',
        component: () => import('../views/customer-app.vue'),
        meta: { title: '客户app', icon: 'Service' }
      },

    ],
    
  },
   // 添加通配符路由（必须放在最后）
   {
    path: '/:pathMatch(.*)*', // 捕获所有未匹配路径
    redirect: '/' // 重定向到根路径
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
// router.beforeEach((to, from, next) => {
//   const token = getToken();
//   console.log(!token && to.name !== "Login",'88888')
//   if (!token && to.name !== "Login") {
//     // 如果没有 token 且目标不是登录页，则重定向到登录页
//     next({ name: "Login" });
//   } else if (token && to.name === "Login") {
//     // 如果有 token 且目标是登录页，则重定向到首页
//     next({ name: "Home" });
//   } else {
//     // 正常导航
//     next();
//   }
// });
export default router